module.exports = __webpack_public_path__ + "img/img27.417eaa18.svg";